var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is_active)?_c('div',[_c('div',{staticClass:"activeUserAvatar"},[_vm._v(_vm._s(_vm.showUpperLetters))])]):_c('div',[_c('div',{staticClass:"userAvatar"},[_vm._v(_vm._s(_vm.showUpperLetters))])])])}
var staticRenderFns = []

export { render, staticRenderFns }